import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getAppointmentCategoriesRequest: null,
  getAppointmentCategoriesSuccess: ["categories"],
  getAppointmentCategoriesFailure: null,
});

export const GetAppointmentCategoriesTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  categories: null,
  error: null,
});

export const GetAppointmentCategoriesSelectors = {
  getData: (state: any) => state.getAppointmentCategories.data,
  isFetching: (state: any) => state.getAppointmentCategories.fetching,
  isSuccess: (state: any) => state.getAppointmentCategories.success,
  hasError: (state: any) => state.getAppointmentCategories.error,
};

export const request = (state: any, action: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    categories: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { categories } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    categories,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    categories: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_APPOINTMENT_CATEGORIES_REQUEST]: request,
  [Types.GET_APPOINTMENT_CATEGORIES_SUCCESS]: success,
  [Types.GET_APPOINTMENT_CATEGORIES_FAILURE]: failure,
});
